import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
	classificationLoadSuccess,
	startClassificationLoad,
	startLoadNsFieldsKeyValues,
} from '@app/pages/cmms/state/cmms.actions';
import { EMPTY, mergeMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuErrorAdapter } from '@app/shared';
import { IconSnackBarService } from '@core/services/icon-snack-bar.service';
import { ClassificationService } from '@app/pages/cmms/services/classification.service';
import { MaintenanceSelectorService } from '@app/pages/cmms/components/au-maintenance-selector/maintenance-selector.service';

@Injectable()
export class CmmsEffects {
	startLoadingClassifications$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(startClassificationLoad),
			mergeMap(({ queryParams }) => {
				return this.classificationService.loadClassifications(queryParams).pipe(
					map(classifications => {
						return classificationLoadSuccess({
							classifications: classifications,
						});
					}),
					catchError(error => {
						this.notify.error(AuErrorAdapter.getTextFromGqlError(error));
						return EMPTY;
					})
				);
			})
		);
	});

	startLoadingMaintenanceSelectorValues$ = createEffect(
		() => {
			return this.actions$.pipe(
				ofType(startLoadNsFieldsKeyValues),
				mergeMap(() => {
					this.maintenanceSelectorService.loadConfigurations();
					return EMPTY;
				})
			);
		},
		{ dispatch: false }
	);

	constructor(
		private actions$: Actions,
		private notify: IconSnackBarService,
		private classificationService: ClassificationService,
		private maintenanceSelectorService: MaintenanceSelectorService
	) {}
}
